import React from 'react'
import {useTranslation} from 'react-i18next'
import {ExpandableLayout} from 'components/Shared/ExpandableLayout'
import styles from './Tabs.module.css'

const ROW_HEIGHT = 48
const VISIBLE_ROWS_COUNT = 3

export default function RowsCollapse({itemsCount, children}) {
    const {t} = useTranslation()

    return (
        <ExpandableLayout collapsedHeight={VISIBLE_ROWS_COUNT * ROW_HEIGHT}
                          collapsedText={t('order.details.history.showMore')}
                          expandedText={t('order.details.history.showLess')}
                          showExpandIcon={itemsCount > VISIBLE_ROWS_COUNT}
                          classes={{expanderBox: styles.expanderBox}}>
            {children}
        </ExpandableLayout>
    )
}
